<template>
<div class="chapter">
<div class="inner_page">
<div class="ContentsPage">
<h1>Contents</h1>
<p><a href="#/Text/Preface">Preface</a></p>
<p><a href="#/Text/Introduction">Introduction: Preaching the Bible way</a></p>
<ol>
<li><a href="#/Text/Chapter1">Jesus Christ, the preacher</a>: Setting the supreme standard</li>
<li><span href="#/Text/Chapter2" title="Link target outside of Sample">Tim Keller</span>: Be aware of cultural and philosophical challenges to the gospel</li>
<li><span href="#/Text/Chapter3" title="Link target outside of Sample">John Piper</span>: Inspire a passion for the glory of God</li>
<li><span href="#/Text/Chapter4" title="Link target outside of Sample">Vaughan Roberts</span>: Let the Bible speak with simplicity and freshness</li>
<li><span href="#/Text/Chapter5" title="Link target outside of Sample">Simon Ponsonby</span>: Be a Word-and-Spirit preacher</li>
<li><span href="#/Text/Chapter6" title="Link target outside of Sample">J.John</span>: Use humour and story to connect and engage, and dismantle barriers</li>
<li><span href="#/Text/Chapter7" title="Link target outside of Sample">David Cook</span>: Create interest; apply well</li>
<li><span href="#/Text/Chapter8" title="Link target outside of Sample">John Ortberg</span>: Preach with spiritual formation in mind</li>
<li><span href="#/Text/Chapter9" title="Link target outside of Sample">Nicky Gumbel</span>: Make much of Jesus Christ</li>
<li><span href="#/Text/Chapter10" title="Link target outside of Sample">Rico Tice</span>: Preach with urgency and evangelistic zeal</li>
<li><span href="#/Text/Chapter11" title="Link target outside of Sample">Alistair Begg</span>: Persuade people by passionate argument from the Bible</li>
<li><span href="#/Text/Chapter12" title="Link target outside of Sample">Mark Driscoll</span>: Teach with directness, challenge and relevance</li>
<li><span href="#/Text/Chapter13" title="Link target outside of Sample">Mark Dever</span>: Expose all of God’s Word to all of God’s people</li>
</ol>
<p><span href="#/Text/Conclusion" title="Link target outside of Sample">Conclusion: Preaching that changes lives</span></p>
<p><span href="#/Text/Appendix" title="Link target outside of Sample">Appendix: The survey and online resources</span></p>
<p><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?32d2f45c